import { report } from '@/api/app';
export default report;
